import axios from 'axios';
import { nanoid } from 'nanoid';
import { getApiBaseUrl } from '@/lib/runtime-env';
import { handleUnauthorized } from './sessionExpiry';

const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers['x-trace'] = nanoid();
  return config;
});

api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  const method = (config.method ?? 'get').toLowerCase();
  if (method === 'get' || method === 'head' || method === 'options') {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
  }

  // Re-resolve every request so a shared image picks up env-specific runtime-env.js
  // (e.g. QA secret DT_VITE_API_URL) instead of a bake-in from another env's build.
  config.baseURL = getApiBaseUrl();

  if (config.url && !config.url.startsWith('http') && !config.url.startsWith('/')) {
    config.url = '/' + config.url;
  }

  return config;
});

// A 401 is the one session-expiry rule (B8). This client's callers (the
// auth provider, the builder) report the expiry themselves: the builder reads
// it as the typed `session_expired` and offers Sign in.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleUnauthorized(error, { redirect: false });
    return Promise.reject(error);
  }
);

/** @deprecated Prefer getApiBaseUrl() — kept for callers that imported API_URL. */
const API_URL = getApiBaseUrl();

export { api as httpClient, API_URL, getApiBaseUrl };
export default api;
